<template>
  <div class="tab">
    <el-select ref="select" v-loading="loading" class="select_multiple" popper-class="select_multiple_popper"
      v-model="selectData.selected" :multiple="selectData.isMultiple" :filterable="selectData.isFilterable"
      :remote="selectData.isRemote" :clearable="isClear" :remote-method="remoteMethod" :loading="loading"
      :size="selectData.size ? selectData.size : ''" @change="changeSelect" value-key="value" @clear="clear"
      @visible-change="isPanelShow" v-loadMore="isScroll ? loadMore : () => { }"
      :disabled="selectData.isDisabled ? true : false"
      :placeholder="selectData.placeholder ? selectData.placeholder : '请选择'">
      <el-checkbox v-model="selectData.isAll" v-if="selectData.isShowAll" @change="selectAll" style="
            width: calc(100% - 40px);
            font-size: 14px;
            padding: 0 20px;
            overflow: hidden;
            color: #606266;
            height: 34px;
            display: flex;
            align-items: center;
          ">全选</el-checkbox>
      <!-- <div v-else-if="selectData.label">
        <el-option
          v-for="(item, index) in selectData.list"
          :key="index"
          :label="item[selectData.label]"
          :value="item[selectData.value]"
        >
          <slot :item="item" v-if="isSlot"></slot>
        </el-option>
      </div> -->
      <div v-else>
        <slot name="header"></slot>
        <div class="selectMultipleTable" v-if="isTable">
          <li class="el-select-group__title"
            style="width: 100%; box-sizing: border-box; display: block; color: #000; font-weight: bold; font-size: 14px; background-color: #fff; position: absolute; z-index: 1; top: 0;">
            <span v-for="(i, index) in columnList" :key="index"
              :style="'width:' + i.width + 'px;' + 'display: inline-block;' + 'padding: 0 2px;'">{{ i.label }}</span>
          </li>
          <li style="height: 24px;"></li>
          <el-option v-for="item in selectData.list" :key="optionKey(item)"
            :label="item[selectData.label ? selectData.label : 'text']"
            :value="selectData.valueIsObj ? item : (item[selectData.value ? selectData.value : 'value'])">
            <span v-for="(i, index) in columnList" :key="index"
              :style="'width:' + i.width + 'px;' + 'display: inline-block;' + 'padding: 0 2px;'">{{ i.formatter ?
                i.formatter(item) : item[i.value] }}</span>
          </el-option>
        </div>
        <template v-else>
          <el-option v-for="item in selectData.list" :key="optionKey(item)"
            :label="item[selectData.label ? selectData.label : 'text']"
            :value="selectData.valueIsObj ? item : (item[selectData.value ? selectData.value : 'value'])">
            <slot :item="item" v-if="isSlot"></slot>
            <div v-else style="display: flex;justify-content: space-between;">
                <div>{{ item.text ? item.text : item.label }}</div>
                <div v-if="suffixText && item.isFreeze == 'Y'" style="color: #ff8940;">{{ suffixText }}</div>
            </div>
          </el-option>
        </template>
      </div>
      <div style="height: 16px" v-if="isScroll">
        <span v-if="localLoading" style="display: block; text-align: center"><i class="el-icon-loading"></i></span>
        <span v-if="!localLoading && selectData.list.length == total"
          style="display: block; text-align: center; color: #606266">暂无更多</span>
      </div>
      <el-pagination v-show="!isScroll && selectData.isPagination" class="select_pagination"
        :current-page="selectData.request.params.page" :page-size="selectData.request.params.size"
        @current-change="handleCurrentChange" hide-on-single-page small layout="prev, pager, next" :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    selectData: Object,
    change: {
      type: Function,
      default: function () { },
    },
    visibleChange: {
      type: Function,
      default: function () { },
    },
    isClear: {
      type: Boolean,
      default: true,
    },
    isSlot: {
      type: Boolean,
      default: false,
    },
    isTable: {
      type: Boolean,
      default: false
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
    optionKey: {
      type: Function,
      default: function (item) { return item.value },
    },
    columnList: {
      type: Array,
      default: () => []
    },
    suffixText: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      loading: false,
      localLoading: false,
      total: 0,
      isRemoteMethod: false,
    };
  },
  directives: {
    loadMore: {
      // 指令的定义
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const CONDITION =
            this.scrollHeight - this.scrollTop - 20 <= this.clientHeight;
          if (CONDITION) {
            binding.value();
          }
        });
      },
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let request = this.selectData.request;
      this.loading = true;
      const option = {
        method: request.type,
        url: request.url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "*/*",
        }, // 解决后端返回参数乱码问题
        data: this.Qs.stringify(request.params),
        params: request.params,
      };
      if (request.type == "post") {
        delete option.params;
      } else if (request.type == "get") {
        delete option.data;
      }
      const { data: res } = await this.$http(option);
      this.loading = false;
      if (res.code != "success") return false;
      res.result = JSON.parse(res.result);
      this.total = res.result.total ? res.result.total : 0;
      let _list = res.result.data ? JSON.parse(res.result.data) : res.result

      // 新增    如果选中有值 就和第一页合并去重
      // if(this.selectData.selected.length && request.params.page === 1) {
      //   let unique = this.resArr(_list, this.selectData.selected)
      //   _list = [...this.selectData.selected, ...unique]
      // } else if(this.selectData.selected.length && request.params.page != 1) {
      //   let unique = this.resArr(_list, this.selectData.selected)
      //   _list = unique
      // }
      // 新增结束

      this.selectData.list = _list.map(i => {
        if (request.text) {
          i.text = i[request.text]
        }
        if (request.value) {
          i.value = i[request.value]
        }
        return i
      });    
    },
    // 去重
    // resArr(arr1, arr2) {
    //   console.log(arr1, arr2)
    //   return arr1.filter((v) => arr2.every((val) => val.value!= v.value))
    // },
    async loadMore() {
      this.selectData.request.params.page++;
      let request = this.selectData.request;
      if (this.selectData.list.length == this.total) return this.localLoading = false;
      this.localLoading = true;
      const option = {
        method: request.type,
        url: request.url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "*/*",
        }, // 解决后端返回参数乱码问题
        data: this.Qs.stringify(request.params),
        params: request.params,
      };
      if (request.type == "post") {
        delete option.params;
      } else if (request.type == "get") {
        delete option.data;
      }
      const { data: res } = await this.$http(option);
      this.localLoading = false;
      if (res.code != "success") return false;
      res.result = JSON.parse(res.result);
      let _list = res.result.data ? JSON.parse(res.result.data) : res.result
      const tempMap = new Map();
      this.selectData.list = [
        ...this.selectData.list,
        ..._list.map(i => {
          if (request.text) {
            i.text = i[request.text]
          }
          if (request.value) {
            i.value = i[request.value]
          }
          return i
        }),
      ].filter(
        (item) => !tempMap.has(item.value) && tempMap.set(item.value, 1)
      ); // 解决滚动加载时，回显造成的key值重复的问题
    },
    selectAll() {
      if (this.selectData.isAll) {
        this.selectData.list.map((item) => {
          this.selectData.selected.push(item.value);
        });
      } else {
        this.selectData.list.map((item) => {
          this.selectData.selected = this.selectData.selected.filter(
            (row) => row != item.value
          );
        });
      }
    },
    changeSelect(val) {
      this.change(val);
    },
    clear() {
      this.selectData.isAll = false;
    },
    remoteMethod(query) {
      this.isRemoteMethod = true;
      this.selectData.request.params["keyWords"] = query;
      this.selectData.request.params.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      let params = this.selectData.request.params;
      params.page = val;
      this.getList();
    },
    isPanelShow(isPanelShow) {
      if (!isPanelShow) {
        if (this.isRemoteMethod) {
          this.remoteMethod("");
          this.isRemoteMethod = false;
        }
      } else {
        if (this.selectData.isReSearch) {
          this.selectData.isReSearch = false;
          this.getList();
        }
      }
      this.visibleChange(isPanelShow);
    },
    // 获取焦点事件
    focus() {
      this.$refs["select"].$nextTick(() => {
        this.$refs["select"].focus();
      });
    },
  },
};
</script>

<style scoped lang="less">
* {
  font-size: 12px;
}

.tab {
  width: 100%;
}

.select_multiple {
  width: 100%;

  ::v-deep .el-select__tags {
    max-height: 80px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.select_pagination {
  text-align: center;
}

/*多选下拉框嵌套表格*/
.selectMultipleTable .el-select-dropdown__item {
  min-height: 34px;
  height: auto;
  white-space: pre-wrap;
  line-height: normal;
  display: flex;
  align-items: center;
}

// .el-select__tags::-webkit-scrollbar {
//   display: none; /* Chrome Safari */
// }

// .el-select__tags {
//   scrollbar-width: none; /* firefox */
//   -ms-overflow-style: none; /* IE 10+ */
//   overflow-x: hidden;
//   overflow-y: auto;
// }
</style>
